import axiosPrivateMl from "@services/axiosPrivateMl"
import { ML_DEFAULT_VALUES_URL } from "../../constants"

export const getDefaultValues = async (userId, adAccountId = null) => {
  try {
    let url = `${ML_DEFAULT_VALUES_URL}/${userId}`
    if (adAccountId) {
      url = `${ML_DEFAULT_VALUES_URL}/${userId}?ad_account_id=${adAccountId}`
    }
    const response = await axiosPrivateMl.post(url)
    return response.data
  } catch (error) {
    console.log(error)
  }
}
